import useLogoUrlReplacement from 'components/Dashboard/UserContent/ui/useLogoUrlReplacement';

interface UploadHubLandingPreviewProps {
  organisationLogo: string | null;
  backgroundColour: string;
}

const UploadHubLandingPreview = (props: UploadHubLandingPreviewProps) => {
  const { organisationLogo, backgroundColour } = props ?? {};
  const { clientLogoReplacement } = useLogoUrlReplacement();
  const logoUrl = organisationLogo?.startsWith('data:')
    ? organisationLogo
    : clientLogoReplacement({ organisationLogo });

  return (
    <div className='rounded border p-3' style={{ backgroundColor: backgroundColour }}>
      <img
        src={logoUrl}
        alt='Organisation logo'
        className='rounded bg-white'
        style={{ width: '32px', height: '32px', objectFit: 'contain' }}
      />
      <div className='bg-white rounded border mt-3 flex-centered justify-content-center' style={{ height: '160px' }}>
        <p className='mb-0 main-light-text'>Your file</p>
      </div>
    </div>
  );
};

export default UploadHubLandingPreview;
